enum DatePeriodsEnum {
  AM = 'AM',
  PM = 'PM',
}

export default DatePeriodsEnum;
